
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Error, LoginContain, RequieredStar } from "../../style/Login/ForgotSendOtp";
import Logo from "../../assets/images/logo.png";
import { useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ForgotSendOTP } from "../../services/authServices";
import { Loader } from "../../utils/loader";

function ForgotSendOtp() {
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false)
    const location = useLocation();
    const responseData = location.state?.data;
    const navigate = useNavigate();
    // Validate the form
    const validateForm = () => {
        let formErrors = {};
        // if (!responseData.userType) formErrors.userType = "User Type is required";
        if (!responseData.adminId.trim()) formErrors.adminId = "Admin ID is required";
        setErrors(formErrors);
        return Object.keys(formErrors).length === 0;
    };

    const handleSubmitOtp = async (e) => {
        try {
            e.preventDefault();
            if (validateForm()) {
                setLoading(true)
                const payload = {
                    adminId: responseData.adminId,
                };
                const res = await ForgotSendOTP(payload);
                if (res && res.success) {
                    toast.success("OTP sent successfully");
                    navigate("/forgotverify-otp", { state: { data: payload } });
                }
                else {
                    toast.error(res.message || "Failed to send OTP");
                }
            }
        } catch (error) {
            setLoading(false)
            toast.error(error?.response?.data?.error ?? "Something went wrong");
        }
        finally {
            setLoading(false);
        }
    };

    return (
        <>
            <ToastContainer />
            <LoginContain>
                <div className="LoginCard">
                    <div className="LoginLogo">
                        <img src={Logo} alt="logo"  loading="lazy" />
                    </div>
                    <div className="LoginTitle">
                        <h4>Forgot Send Otp</h4>
                        <p>LMS support team is just a tap away!</p>
                    </div>
                    <form onSubmit={handleSubmitOtp}>
                        <div className="LoginGroup">
                            <label htmlFor="admin-id" className="forgot-label">
                                Admin Email
                            </label>
                            <input
                                type="text"
                                id="user-id"
                                className="forgot-input"
                                placeholder={responseData?.emailId}
                                readOnly
                            />
                            {/* {errors.userType && <Error>{errors.userType}</Error>} */}
                        </div>
                        <div className="LoginGroup">
                            <label htmlFor="user-id" className="forgot-label">
                                admin Mobile
                            </label>
                            <input
                                type="text"
                                id="user-id"
                                className="forgot-input"
                                placeholder={responseData?.phoneNumber}
                                readOnly
                            />
                            {errors.adminId && <Error>{errors.adminId}</Error>}
                        </div>
                        <div className="LoginGroup LoginBtn">
                            <button type="submit" disabled={loading}> {loading ? <Loader /> : "Send"}</button>
                        </div>
                    </form>
                </div>
            </LoginContain>
        </>
    );
}

export default ForgotSendOtp;
